import type {FluxStore} from '@nlabs/arkhamjs';

export const homepageStore: FluxStore = {
  name: 'homepage',
  initialState: {
    liveArticles: [],
    status: 'loading',
    weather: undefined,
    weatherStatus: 'loading'
  },
  action: (type, data, state) => {
    if(type === 'HOMEPAGE_REPLACE') return {...state, articles: data.articles};
    if(type === 'ARTICLE_FEED_REPLACE') return {...state, liveArticles: data.articles, status: data.status};
    if(type === 'WEATHER_REPLACE') return {...state, weather: data.weather, weatherStatus: data.status};
    return state;
  }
};
